import { Content } from '../../types';

export const thailandMyanmarBorderTripContent: Content = {
  title: 'טיול יום בצפון תאילנד לאורך כביש 1149 - גבול תאילנד-מיאנמר',
  imageUrl:
    '/images/thailand/thailand-mianmar-border-trip/thailand-mianmar-border-trip-wide.jpeg',
  introduction: `אם הינכם מעוניינים בטיול יום מעניין ומומלץ באזור צ'אנג ראי, נמליץ לכם לשקול נסיעה לאורך כביש 1149, העובר בסמוך לגבול תאילנד-מיאנמר (בורמה). הכביש מציע נופים מרהיבים, תצפיות פנורמיות, אתרים היסטוריים ותרבותיים, כפרים מסורתיים ושווקים ייחודיים.`,
  sections: [
    {
      title: "תחילת המסלול - מצ'אנג מאי לדוי טונג",
      type: 'sub-headers',
      description:
        "המסלול מתחיל בנסיעה צפונה מצ'אנג מאי לכיוון צ'אנג ראי ושילוב בכביש 1149 המוביל לאזור דוי טונג:",
      content: [
        {
          subtitle: "דרך הגישה מצ'אנג מאי",
          text: "הטיול מתחיל בצ'אנג מאי, ממנה נצא צפונה על כביש 1 לכיוון צ'אנג ראי. לאחר כ-45 ק\"מ נפנה שמאלה אל כביש 1149, המוביל לאזור דוי טונג (Doi Tung).",
        },
        {
          subtitle: 'נוף הדרך המתפתלת',
          text: 'הדרך המטפסת מעלה מתפתלת בין הרים ירוקים ועוברת דרך משתלות רבות, בהן ניתן למצוא מגוון צמחים ופרחים אקזוטיים.',
        },
      ],
    },
    {
      title: 'תצפיות ונופים עוצרי נשימה',
      type: 'sub-headers',
      description:
        'לאורך כביש 1149 תמצאו נקודות תצפית מרהיבות המציעות נופים פנורמיים של האזור ההררי:',
      content: [
        {
          subtitle: 'Km. 12 Viewpoint',
          text: 'תצפית פנורמית מדהימה על האזור ההררי.',
        },
        {
          subtitle: 'Tent Viewpoint',
          text: 'נקודת תצפית נוספת המציעה נוף רחב היקף.',
        },
      ],
    },
    {
      title: 'גני המלכה האם וארמון הקיץ',
      type: 'text',
      content:
        'אחד האתרים הבולטים במסלול הוא גני המלכה האם, הכוללים את ארמון הקיץ של אימו של המלך ראמה ה-9. הגנים מטופחים ומלאים בפרחים ססגוניים, מזרקות ושבילי הליכה נעימים. במקום קיים גם שוק מקומי המציע מוצרים מסורתיים מתוצרת שבטי ההרים באזור.',
    },
    {
      title: 'מקדשים, מוצבים ונקודות תצפית מיוחדות',
      type: 'sub-headers',
      description:
        'בהמשך הנסיעה תוכלו לבקר במספר אתרים תרבותיים והיסטוריים מרתקים:',
      content: [
        {
          subtitle: 'Wat Phra That Doi Tung',
          text: 'מקדש מרשים עם פגודה מוזהבת ותצפית מרהיבה על האזור.',
        },
        {
          subtitle: 'Cang Moob',
          text: 'מוצב צבאי לשעבר המשמש כיום כנקודת תצפית מדהימה לעבר מיאנמר.',
        },
        {
          subtitle: 'Pha Hi Village',
          text: 'כפר של שבט מקומי הבנוי על צלע הר, בו ניתן למצוא בתי הארחה, מסעדות ובתי קפה עם נוף עוצר נשימה.',
        },
        {
          subtitle: 'Pha Mi Village',
          text: 'כפר מסורתי נוסף של שבט מקומי, המציע חוויה אותנטית למבקרים.',
        },
        {
          subtitle: 'PA Sak Checkpoint',
          text: 'נקודת תצפית נוספת עם נוף פנורמי על הגבול עם מיאנמר.',
        },
      ],
    },
    {
      title: 'מעבר הגבול במאה סאי (Mae Sai)',
      type: 'text',
      content:
        'לבסוף, נגיע לעיירה מאה סאי (Mae Sai), השוכנת על נהר ה-Roak, המשמש כגבול טבעי בין תאילנד למיאנמר. במקום קיים מעבר גבול רשמי ושוק גדול עם מגוון מוצרים, רבים מהם מגיעים ממיאנמר.',
    },
    {
      title: "חזרה לצ'אנג ראי",
      type: 'text',
      content:
        "לאחר הביקור במאה סאי, ניתן לשוב לצ'אנג ראי דרך כביש מספר 1, לסיום יום מלא בחוויות, נופים ואתרים ייחודיים",
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, זהו מסלול מושלם לחובבי טבע, תרבות והיסטוריה, המשלב בין נופים עוצרי נשימה לבין מפגש עם התרבות המקומית והשבטים החיים באזור.`,
      type: 'text',
      isBold: true,
    },
  ],
};
